import { StatusBadge, type IStatusBadgeProps } from '@procurify/ui'
import { type IntlShape } from 'react-intl'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import {
  ExpenseStatuses,
  type ExpenseStatusEnum,
} from '../../entities/enums/ExpenseStatusEnum'

const getType = (status: ExpenseStatusEnum) => {
  switch (status) {
    case ExpenseStatuses.PENDING:
      return 'warning'
    case ExpenseStatuses.APPROVED:
      return 'success'
    case ExpenseStatuses.DENIED:
      return 'error'
    case ExpenseStatuses.DRAFT:
      return 'warning'
    default:
      return 'inactive'
  }
}

const getText = (intl: IntlShape, status: ExpenseStatusEnum) => {
  switch (status) {
    case ExpenseStatuses.PENDING:
      return intl.formatMessage(messages.statusTextPending)
    case ExpenseStatuses.APPROVED:
      return intl.formatMessage(messages.statusTextApproved)
    case ExpenseStatuses.DENIED:
      return intl.formatMessage(messages.statusTextDenied)
    case ExpenseStatuses.DRAFT:
      return intl.formatMessage(messages.statusTextDraft)
    default:
      return intl.formatMessage(messages.statusTextUnknown)
  }
}

interface IExpenseStatusLabelProps {
  status: ExpenseStatusEnum
  size?: IStatusBadgeProps['size']
}

export const ExpenseStatusLabel = ({
  status,
  size = 'medium',
}: IExpenseStatusLabelProps) => {
  const intl = useProcurifyIntl()

  return (
    <StatusBadge
      aria-label={intl.formatMessage(messages.statusAriaLabel)}
      size={size}
      type={getType(status)}
      text={getText(intl, status)}
    />
  )
}
